import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle, Lock, CreditCard, X } from "lucide-react";
import api from "@/lib/api";

const money = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const hoyKey = () => `preaviso-cobro-${new Date().toISOString().slice(0, 10)}`;

const Pagar = ({ testid, dark }) => (
  <Link to="/cobro-sistema" data-testid={testid} className={`ml-auto h-8 px-3 rounded-full font-bold text-xs flex items-center gap-1 ${dark ? "bg-white text-rose-700" : "bg-brand-ink text-white"}`}><CreditCard className="w-3.5 h-3.5" /> Pagar ahora</Link>
);

/** Barras de costo de sistema: preaviso (cerrable) 2 y 1 día antes de fin de mes; aviso persistente días 1-2; bloqueo desde el día 3. */
export default function AvisoMorosidad() {
  const [e, setE] = useState(null);
  const [cerrado, setCerrado] = useState(() => !!localStorage.getItem(hoyKey()));
  const loc = useLocation();
  useEffect(() => { api.get("/cobro-sistema/estado").then((r) => setE(r.data)).catch(() => {}); }, [loc.pathname]);
  if (!e?.aplica || loc.pathname === "/cobro-sistema") return null;
  if (e.bloqueado) return (
    <div className="bg-rose-700 text-white px-4 py-2 text-sm flex flex-wrap items-center gap-3" data-testid="aviso-morosidad-bloqueo">
      <Lock className="w-4 h-4" /><b>Sucursal bloqueada:</b> costo de sistema vencido ({money(e.monto_vencido)}). No se pueden registrar ventas hasta regularizar el pago.
      <Pagar testid="aviso-morosidad-pagar" dark />
    </div>
  );
  if (e.aviso) return (
    <div className="bg-brand-amber text-brand-ink px-4 py-1.5 text-xs flex flex-wrap items-center gap-2" data-testid="aviso-morosidad">
      <AlertTriangle className="w-3.5 h-3.5" /><b>Costo de sistema de {e.mes_pendiente} pendiente</b> · {money(e.monto_pendiente)} · el día {e.dia_bloqueo} se bloquearán las ventas ({e.dias_para_bloqueo} día(s)).
      <Pagar testid="aviso-morosidad-link" />
    </div>
  );
  if (e.preaviso && !cerrado) {
    const d = e.dias_para_fin_mes;
    return (
      <div className="bg-brand-amber text-brand-ink px-4 py-1.5 text-xs flex flex-wrap items-center gap-2" data-testid="aviso-preaviso">
        <AlertTriangle className="w-3.5 h-3.5" /><b>{d === 0 ? "Hoy termina el mes" : `Resta${d === 1 ? "" : "n"} ${d} día${d === 1 ? "" : "s"} para finalizar el mes`}</b> · ya puedes realizar el pago del costo de sistema de {e.mes_pendiente} ({money(e.monto_pendiente)}).
        <Pagar testid="aviso-preaviso-pagar" />
        <button type="button" data-testid="aviso-preaviso-cerrar" aria-label="Cerrar aviso" onClick={() => { localStorage.setItem(hoyKey(), "1"); setCerrado(true); }} className="h-7 w-7 rounded-full hover:bg-black/10 flex items-center justify-center"><X className="w-4 h-4" /></button>
      </div>
    );
  }
  return null;
}
